import { useEffect, useState } from "react"

const defaultLocation = {
  latitude: 48.404675,
  longitude: 2.70162,
}
const useGeolocation = (
  { enableHighAccuracy, maximumAge, timeout } = {},
  callback,
) => {
  const [numTimesChecked, setNumTimesChecked] = useState(0)
  const [coordinates, setCoordinates] = useState({
    accuracy: null,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    latitude: null,
    longitude: null,
    speed: null,
    timestamp: null,
    error: null,
  })

  useEffect(() => {
    let didCancel
    const updateCoordinates = ({ coords = {}, timestamp }) => {
      const {
        accuracy,
        altitude,
        altitudeAccuracy,
        heading,
        latitude,
        longitude,
        speed,
      } = coords
      if (!didCancel) {
        setCoordinates({
          accuracy,
          altitude,
          altitudeAccuracy,
          heading,
          latitude,
          longitude,
          speed,
          timestamp,
          numTimesChecked,
          error: null,
        })
        if (callback instanceof Function) {
          callback({
            accuracy,
            altitude,
            altitudeAccuracy,
            heading,
            latitude,
            longitude,
            speed,
            timestamp,
            numTimesChecked,
            error: null,
          })
        }
      }
    }

    const setError = (error) => {
      if (!didCancel) {
        setCoordinates({
          accuracy: null,
          altitude: null,
          altitudeAccuracy: null,
          heading: null,
          latitude: defaultLocation.latitude,
          longitude: defaultLocation.longitude,
          speed: null,
          timestamp: null,
          error,
          numTimesChecked,
        })
      }
    }

    let watchId
    if (navigator.geolocation) {
      // not compatible with some browsers
      try {
        navigator.permissions.query({ name: "geolocation" }).then((result) => {
          result.addEventListener("change", () => {
            navigator.geolocation.getCurrentPosition(
              updateCoordinates,
              setError,
            )
          })
        })
      } catch (e) {}
      navigator.geolocation.getCurrentPosition(updateCoordinates, setError)
      watchId = navigator.geolocation.watchPosition(
        updateCoordinates,
        setError,
        { enableHighAccuracy, maximumAge, timeout },
      )
    }
    return () => {
      if (watchId) {
        navigator.geolocation.clearWatch(watchId)
      }
      didCancel = true
    }
  }, [callback, enableHighAccuracy, maximumAge, numTimesChecked, timeout])

  return { ...coordinates, setNumTimesChecked } || {}
}

export default useGeolocation
